import React from "react";
import {Form, Input, Modal, Select} from "antd"
import {HearAboutUs} from "../../../filters/marketing/HearAboutUs";
import {LeadLevel} from "../../../filters/marketing/LeadLevel";
import {AddPhone} from "./AddPhone";
import {AddAddress} from "./AddAddress";
import {CallLogPost} from "../../../models/marketing/callLog";

const {Option} = Select;
const FormItem = Form.Item;
const {TextArea} = Input;

class AddCallForm extends React.Component {

  handleAddCall = () => {
    const {form} = this.props;
    form.validateFields((err, values) => {
      console.log(values, "old values");
      if (!err) {
        CallLogPost(values)
          .then(response => {
            console.log("response", response);
            this.props.fetch();
            this.props.onClose()
          })
      }
    })
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Modal title="New Call/Lead" width={"60%"} onOk={this.handleAddCall} visible={this.props.visible}
             onCancel={this.props.onClose}>
        <div className="row full-floating-inputs">
          <div className="col-12">
            <div className="floating-label">
              <FormItem label="How did the customer hear about us?">
                {getFieldDecorator('hear_about_us', {
                  rules: [{required: true, message: 'Choose Hear About Us'}],
                })(<HearAboutUs onRef={ref => (this.hear_about_us = ref)}/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-6 col-12">
            <div className="floating-label">
              <FormItem label="First Name">
                {getFieldDecorator('first_name', {
                  rules: [{required: true, message: 'Please enter first name'}],
                })(<Input placeholder="Enter Here"/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-6 col-12">
            <div className="floating-label">
              <FormItem label="Last Name">
                {getFieldDecorator('last_name', {
                  rules: [{required: true, message: 'Please enter last name'}],
                })(<Input placeholder="Enter Here"/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-6 col-12">
            <div className="floating-label">
              <FormItem label="Company Name">
                {getFieldDecorator('company_name', {
                  rules: [{required: true, message: 'Please enter company name'}],
                })(<Input placeholder="Enter Here"/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-6 col-12">
            <div className="floating-label">
              <FormItem label="Email">
                {getFieldDecorator('email', {
                  rules: [
                    {required: true, message: 'Please enter email'},
                    {type: 'email', message: 'The input is not valid E-mail!'}],
                })(<Input placeholder="Enter Here"/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-6 col-12">
            <div className="floating-label">
              <FormItem>
                {getFieldDecorator('phones', {
                  rules: [
                    {required: true, message: 'Please enter phone'}],
                })(<AddPhone onRef={ref => (this.phone = ref)}/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-6 col-12">
            <div className="floating-label">
              <FormItem>
                {getFieldDecorator('address', {
                  rules: [{required: true, message: 'Please enter address'}],
                })(<AddAddress onRef={ref => (this.address = ref)}/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-4 col-12">
            <div className="floating-label">
              <FormItem label="Lead Level">
                {getFieldDecorator('lead_level', {
                  rules: [{required: true, message: 'Choose Lead Level'}],
                })(<LeadLevel onRef={ref => (this.lead_level = ref)}/>)}
              </FormItem>
            </div>
          </div>
          <div className="col-sm-8 col-12">
            <div className="floating-label">
              <FormItem label="Notes">
                {getFieldDecorator('notes', {})(<TextArea autosize={{minRows: 1, maxRows: 8}} placeholder="Enter Here"/>)}
              </FormItem>
            </div>
          </div>
        </div>
      </Modal>

    )
  }
}

export const AddCall = Form.create()(AddCallForm);


// WEBPACK FOOTER //
// ./src/pages/ab-marketing/popup/AddCall.jsx